import styled from 'styled-components';
import { getTranslatedText, DeleteModal } from '@nile/components';
import React from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

export default function EditCell(props) {
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const { actions, labels } = cell.column;
  return (
    <div
      className="ml8 deleteItem cursor-pointer"
      onClick={() => {
        actions.click(cell.row.original);
      }}
    >
      <div id={`delete-list-item${cell?.row?.id ? `-${cell.row.id}` : ''}`}>
        <SVGIcon name="Edit" />
      </div>
    </div>
  );
}
